export const format2DHeatmap = (
  arr: [number, number, number][],
  heatmapSizes: [number, number],
  approxPoints?: [number, number, number][],
  approximate?: boolean
): number[][] => {
  let result: number[][] = []

  for (let i = 0; i < heatmapSizes[0]; i++) {
    let row: number[] = []
    for (let j = 0; j < heatmapSizes[1]; j++) {
      row[j] = 0
    }
    result.push(row)
  }

  const arrLength = arr.length
  for (let i = 0; i < arrLength; i++) {
    result[arr[i][1]][arr[i][0]] = arr[i][2]
  }
  if (approximate && approxPoints?.length) {
    for (let i = 0; i < approxPoints.length; i++) {
      result[approxPoints[i][1]][approxPoints[i][0]] = approxPoints[i][2]
    }
  }

  return result.reverse()
}
